
// PRE REGISTRATIONS
export const GET_PRE_REGISTRATIONS = "/pre-registrations";
export const ADD_NEW_PRE_REGISTRATION = "/pre-registrations";
export const UPDATE_PRE_REGISTRATION = "/pre-registrations";
export const APPROVE_PRE_REGISTRATION = "/pre-registrations";
export const REJECT_PRE_REGISTRATION = "/pre-registrations";
export const DELETE_PRE_REGISTRATION = "/pre-registrations";
export const GET_PRE_REGISTRATION_BY_UUID = "/pre-registrations";


